export interface IContactDetails {
  id?: string;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  countryCode?: string | null;
  stateCode?: string | null;
  pincode?: string | null;
  contactNumber?: string | null;
  mobileNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  stayDuration?: string | null;
  createDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  relationCodeId?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export const defaultValue: Readonly<IContactDetails> = {
  active: false,
};
